import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { useMutateReactivateLegalEntity } from '@webapp/platform/legal-entities/features/reactivate-legal-entity/models'
import messages from './messages'

interface ReactivateLegalEntityInput {
  uuid: string
  name: string
}

/**
 * Drives the "Enable entity" action from both the list row and the details
 * page. There is no confirmation step (per Figma) — the command fires the
 * mutation and surfaces a success/error toast. `name` is only used for the
 * success copy ("{name} is active again").
 */
export const useReactivateLegalEntityPresenter = () => {
  const { reactivate, isLoading } = useMutateReactivateLegalEntity()
  const intl = useProcurifyIntl()

  const reactivateLegalEntity = async ({
    uuid,
    name,
  }: ReactivateLegalEntityInput) => {
    try {
      await reactivate({ uuid })

      toast.success({
        title: intl.formatMessage(messages.successToastTitle, { name }),
      })
    } catch (error) {
      const errorMessage =
        getMessageFromError(error) ||
        intl.formatMessage(messages.defaultErrorMessage)

      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children: errorMessage,
      })
    }
  }

  return {
    commands: {
      reactivate: reactivateLegalEntity,
    },
    states: {
      isLoading,
    },
  }
}
